import { render, staticRenderFns } from "./GrindingOne.vue?vue&type=template&id=36be9786&scoped=true"
import script from "./GrindingOne.vue?vue&type=script&lang=js"
export * from "./GrindingOne.vue?vue&type=script&lang=js"
import style0 from "./GrindingOne.vue?vue&type=style&index=0&id=36be9786&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36be9786",
  null
  
)

export default component.exports